import { GraphQLResult, generateClient } from "aws-amplify/api";
import { FieldInstance } from "db/definitions";
// @ts-ignore
import { batchGetFieldInstances } from "../graphql/queries";

interface QueryResult {
	batchGetFieldInstances: FieldInstance[];
}

async function batchRetrieveFieldInstances(ids: string[]): Promise<FieldInstance[]> {
	const client = generateClient({ authMode: "userPool" });
	const result = (await client.graphql({
		query: batchGetFieldInstances,
		variables: { ids },
		authMode: "userPool",
	})) as unknown as GraphQLResult<QueryResult>;
	return result.data.batchGetFieldInstances;
}

export default batchRetrieveFieldInstances;
